<template>
    <section>
        <el-dialog
  :title="storeLanguage=='en'?'Title':'配置列'"
  visible
  width="60%"
  :before-close="modalClose">  
  <div class="icon-content w-100 dialog-50 " >
	   
 <el-table
   :data="columnsList"
   highlight-current-row
 		ref="multipleTable"
   style="width: 50%;float: left;"
   @select="selectChange"
     @select-all="selectAllChange"
   :height="height/2-(66+10)"
 >
  <template slot="empty">
 		  <el-empty description="暂时没有数据"></el-empty>
 </template>
  <el-table-column
       type="selection"
       >
     </el-table-column>
	 <el-table-column
	       type="index" label="行号"
	       width="50">
	     </el-table-column>
	<el-table-column  prop='props' label='字段' >
		<template  slot="header" slot-scope="scope">
					<el-input  size="mini"  clearable  @clear="clearClick"    placeholder="搜索字段" v-model="name"  >
					   <el-button  type="primary" slot="append" @click="searchClick(scope)" icon="el-icon-search"></el-button>
					 </el-input>
			      </template>
				 <template slot-scope="scope"><div style="line-height: 32px;">{{scope.row.props}}</div> </template>
	</el-table-column>
	 	<el-table-column   prop='name' label='标题' >
			<template  slot="header" slot-scope="scope">
						<el-input   size="mini" clearable @clear="clearClick" placeholder="搜索标题" v-model="title"  >
						   <el-button  type="primary" slot="append" @click="searchClick(scope)" icon="el-icon-search"></el-button>
						 </el-input>
				      </template>
		</el-table-column>
 <!-- <el-table-column  prop='props' label='列字段名' ></el-table-column>
	<el-table-column   prop='name' label='标题' ></el-table-column> -->
	 		
<!-- <el-table-column prop="" label="必须显示">
		   <template slot-scope="scope">
		  <div  >{{scope.row.isShow?"是":""}}</div>
		   </template>
		 </el-table-column> -->
		<!-- <el-table-column prop="" label="排序">
		   <template slot-scope="scope">
		  <el-input type="number" v-model="scope.row.orders"></el-input>
		   </template>
		 </el-table-column> -->
		<!-- <el-table-column prop="" label="宽度">
		   <template slot-scope="scope">
		  <el-input type="number" v-model="scope.row.width"></el-input>
		   </template>
		 </el-table-column> -->
		
		<!-- <el-table-column prop="" label="是否固定">
		   <template slot-scope="scope">
		  <el-switch  v-model="scope.row.isFixed"></el-switch>
		   </template>
		 </el-table-column> -->
		 <!-- <el-table-column  width="80" prop="" label="有颜色">
		   <template slot-scope="scope">
		  <el-switch  v-model="scope.row.isColor"></el-switch>
		   </template>
		 </el-table-column> -->
 		<!-- <el-table-column prop="" label="是否排序">
 		  <template slot-scope="scope">
 		 <el-switch  v-model="scope.row.isOrders"></el-switch>
 		  </template>
 		</el-table-column> -->
		
 </el-table>
 <el-table
    :data="oklist"
    highlight-current-row
  		
    style="width: 50%;"
    :height="height/2-(66+10)"
  >
   <template slot="empty">
  		  <el-empty description="暂时没有数据"></el-empty>
  </template>
  <!-- <el-table-column
        type="selection"
        >
      </el-table-column> -->
	 
 <!-- 	<el-table-column  prop='props' label='字段' >
 		<template  slot="header" slot-scope="scope">
 					<el-input  size="mini"  clearable  @clear="clearClick"    placeholder="搜索字段" v-model="name"  >
 					   <el-button  type="primary" slot="append" @click="searchClick(scope)" icon="el-icon-search"></el-button>
 					 </el-input>
 			      </template>
 				 <template slot-scope="scope"><div style="line-height: 32px;">{{scope.row.props}}</div> </template>
 	</el-table-column>
 	 	<el-table-column   prop='name' label='标题' >
 			<template  slot="header" slot-scope="scope">
 						<el-input   size="mini" clearable @clear="clearClick" placeholder="搜索标题" v-model="title"  >
 						   <el-button  type="primary" slot="append" @click="searchClick(scope)" icon="el-icon-search"></el-button>
 						 </el-input>
 				      </template>
 		</el-table-column> -->
		<el-table-column  prop='props' label='字段' >
				<template  slot="header" slot-scope="scope">
							<div style="line-height:28px ;">字段</div>
					      </template>
			</el-table-column>
 <!-- <el-table-column  prop='props' label='字段' ></el-table-column> -->
 	<el-table-column   prop='name' label='标题' ></el-table-column>
 	 		
 <!-- <el-table-column prop="" label="必须显示">
 		   <template slot-scope="scope">
 		  <div  >{{scope.row.isShow?"是":""}}</div>
 		   </template>
 		 </el-table-column> -->
 		<el-table-column prop="" label="排序">
 		   <template slot-scope="scope">
 		  <el-input type="number" v-model="scope.row.orders"></el-input>
 		   </template>
 		 </el-table-column>
 		<!-- <el-table-column prop="" label="宽度">
 		   <template slot-scope="scope">
 		  <el-input type="number" v-model="scope.row.width"></el-input>
 		   </template>
 		 </el-table-column> -->
 		
 		 <el-table-column prop="" label="是否固定">
 		   <template slot-scope="scope">
 		  <el-switch  v-model="scope.row.isFixed"></el-switch>
 		   </template>
 		 </el-table-column>
		 <el-table-column label="操作">
		 			  <template  slot-scope="scope">
		 				   <el-button  @click="okcolumnDeleteClick(scope)" type="text" size="small">删除</el-button>
		 			  </template>
		 </el-table-column>
 		 <!-- <el-table-column  width="80" prop="" label="有颜色">
 		   <template slot-scope="scope">
 		  <el-switch  v-model="scope.row.isColor"></el-switch>
 		   </template>
 		 </el-table-column> -->
  		<!-- <el-table-column prop="" label="是否排序">
  		  <template slot-scope="scope">
  		 <el-switch  v-model="scope.row.isOrders"></el-switch>
  		  </template>
  		</el-table-column> -->
 		
  </el-table>
          </div>
  <span slot="footer" class="dialog-footer">
    <el-button @click="modalClose">{{$t("dialog.cancel")}}</el-button>
    <el-button type="primary" @click="okmodalClose">{{$t("dialog.confirm")}}</el-button>
  </span>
</el-dialog> 
</section>
</template>
<script>
 import { listToTree } from "../../js/common.js";
  export default {
	
    data() {
      return {
		  height:window.screen.height,
        columnsList:[],
		oklist:[],
		sourceList:[],
		name:'',
		title:'',
      };
    },
    methods: {
		deleteClick(e){
			if(e.row.id){
				this.$axios.post(`/api/Columns/PostColumnsDelete` ,JSON.stringify(e.row.id.toString())).then(e => {
					 this.$message.success('删除成功到同步服务器');
							this.callbackIndex(this.pageIndex);
				  }); 
			}
			this.columnsList.splice(e.$index,1); 
		},
		appendClick(){
			this.columnsList.unshift({
isColor: false,
isFixed: false,
isOrders: false,
isShow: false,
name: "",
nameEnglish: '',
orders: 0,
props: "",
status: 1,
statusExt: 0,
statusType: 0,
tableName: this.pageName,
isAdd:true,
width: 0})
			//这里
		},
    modalClose(e) {
       this.$store.commit("saveOperate", "");
    },
	okmodalClose(){
	let list=	this.oklist;
	if(list.length==0){this.$message.warning('请勾选条目');return;}
	list.map(item=>item.roleId=this.$store.state.user.roleId)
	var path=this.$route.fullPath.substring(1,this.$route.fullPath.length)
	list.map(item=>item.tableName=path)
	list.map(item=>item.menuName=path.split('?')[0])
	this.$axios.post('/api/Columns/PostColumnsAccount',list).then(e => {
	  this.$emit("callbackColumns", "1")
	  this.$store.commit("saveOperate", "");
	});
	},
	okcolumnDeleteClick(e){
		this.oklist.splice(e.$index,1)
	},
	searchClick(scope){
		let list=this.sourceList;
		if(this.name){
			list=list.filter(item=>item.props.indexOf(this.name)>-1)
		}
		if(this.title){
			list=list.filter(item=>item.name.indexOf(this.title)>-1)
		}
		this.columnsList=list;
	},
	clearClick(){
		this.columnsList=this.sourceList;
	},
	selectAllChange(selection){
		let list=selection;
		if(list.length==0){
		   this.columnsList.forEach(item=>{
			  let index=this.oklist.findIndex(items=>item.props==items.props);
			  if(index>-1){
			  this.oklist.splice(index,1)}
		   })
		}else{
			list.forEach((item,i)=>{
								  let index=this.oklist.findIndex(items=>item.props==items.props);
								  if(index==-1){
								  this.oklist.push(list[i])}
			})
		}
			this.oklist.map((item,i)=>item.orders=(i+1))
	},
	selectChange(selection,row){
		let selected=selection.length>0&&selection.findIndex(item=>item.props==row.props)>-1?true:false;
	    let index=this.oklist.findIndex(item=>item.props==row.props);
		 if(index>-1&&!selected){
		 this.oklist.splice(index,1)}
		 else if(index==-1&&selected){
		  this.oklist.push(row)}
		this.oklist.map((item,i)=>item.orders=(i+1));
	
	},
    },mounted() {
		let path=this.$route.fullPath.substring(1,this.$route.fullPath.length);
  this.$axios.get('/api/Columns/GetColumnsAccountQuery',{params:{tableName:path,roleId:this.$store.state.user.roleId,menuName:path.split('?')[0]}}).then(e => {
    this.columnsList=e;
    this.sourceList=e;
	if(e.length==0){
		  this.$message.warning(this.$store.state.menu.name+'没有配置列表信息');
		  return;
	}
	this.$setTimeout(200).then(s=>{
		e.forEach(item=>{
					if(item.isShow){
					 this.$refs.multipleTable.toggleRowSelection(item,true);	
					}
		})
		this.oklist=e.filter(item=>item.isShow)
		this.oklist.map((item,i)=>item.orders=(i+1));
	})
	
  });
  
 
 },computed: {
    storeLanguage() {
      return this.$store.state.language;
    },
    
  }
  };
</script>